// src/auth/ProtectedRoute.js

import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "./useAuth";

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user } = useAuth();

  // --- As Per Jithu's told remove protection from route :: start:: sheet line no 32
  // if (user === null) {
  //     // Show a loading indicator or some placeholder while user state is being restored
  //     return <Navigate to="/signin" />;
  // }

  // if (!user) {
  //     return <Navigate to="/signin" />;
  // }
  // --- As Per Jithu's told remove protection from route :: end

  // if (requiredRole && user.role !== requiredRole) {
  //     return <Navigate to="/forbidden" />;
  // }

  return children;
};

export default ProtectedRoute;
